module.exports = __webpack_public_path__ + "static/img/rightImg.b793a39.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pageTwo/rightImg.png
// module id = IGE/
// module chunks = 0